export const requiredLanguageContent = {
    'required': {
        'en': 'Required',
        'ar': 'مطلوب',
        'ht': 'Obligatwa',
        'pl': 'Wymagany',
        'pt': 'Obrigatório',
        'sr': 'Потребан',
        'es': 'Requerido',
        'vi': 'Yêu cầu',
        'zh': '必需的',
        'ne': 'आवश्यक छ'
    },
}